import lenisScroll from './_components/lenisScroll';

import jWaypoints from './jquery.waypoints';
import loading from './_components/loading';
import slick from './_components/slick';
//import preloader from './_components/preloader';
import deviceJudge from './_components/ua';
import lazy from './_components/lazy';
import animate from './_components/animate';
import tel from './_components/tel';
//import visual from './_components/visual';
import pagetop from './_components/pagetop';
import smoothScroll from './_components/smoothScroll';
import close from './_components/close';
//import truncate from './_components/truncate';
import cursor from './_components/cursor';
import counter from './_components/counter';
import charts from './_components/chart';
import kvLogoCursor from './_components/kvLogoCursor';
import pageTransition from './_components/pageTransition';
//import instagramFeed from './_components/instagramFeed';

(function () {
  lenisScroll.init();

  // デバイス判定
  deviceJudge.init();

  // ローダー
  //preloader.init();

  // ローダー
  loading.init();

  // slick
  slick.init();

  // TEL
  tel.init();

  // visual
  //visual.init();

  // pagetop
  pagetop.init();

  // smoothScroll
  smoothScroll.init();

  // close
  close.init();

  // truncate
  //truncate.init();

  // cursor
  cursor.init();

  // counter
  counter.init();

  // KVロゴ マウス追従
  kvLogoCursor.init();

  // ページ遷移シャッター
  pageTransition.init();

  charts.initBarChart();
  charts.initPieChart();
  charts.initPieChartMaleToFemaleRatio();

  // instagramFeed
  //instagramFeed.init();

  // PC用：トグルメニューはどこクリックしても閉じるように
  if (!navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)) {
    $(document).click(function (event) {
      var clickover = $(event.target);
      var $navbar = $('.collapse');
      var _opened = $navbar.hasClass('show');
      if (_opened === true && !clickover.hasClass('navbar-toggle')) {
        $navbar.collapse('hide');
      }
    });
  }

  // SP用トグルメニューはどこクリックしても閉じるように
  if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)) {
    $(document).on('click tap', function (e) {
      var clickover = $(e.target);
      var $navbar = $('.collapse');
      var _opened = $navbar.hasClass('show');
      if (_opened === true && !clickover.hasClass('toggle')) {
        $navbar.collapse('hide');
      }
    });
  }
})();
